"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torchiara": {
    "a4c96bf3": [{
      "hkey": "8d4b13ea",
      "slug": "copersito-sant-antuono",
      "name": "Copersito-Sant'Antuono",
      "primary": true,
      "skipSearch": false
    }],
    "copersito": [{
      "hkey": "8d4b13ea",
      "slug": "copersito-sant-antuono",
      "name": "Copersito-Sant'Antuono",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d481dcb2": [{
      "hkey": "73dad01b",
      "slug": "torchiara",
      "name": "Torchiara",
      "primary": true,
      "skipSearch": false
    }],
    "san-teodoro": [{
      "hkey": "73dad01b",
      "slug": "torchiara",
      "name": "Torchiara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0fbaa7f": [{
      "hkey": "8d4b13ea",
      "slug": "copersito-sant-antuono",
      "name": "Copersito-Sant'Antuono",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antuono": [{
      "hkey": "8d4b13ea",
      "slug": "copersito-sant-antuono",
      "name": "Copersito-Sant'Antuono",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torchiara"
    }]
  }
};
exports["default"] = _default;